// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-content {
  --background: var(--cms-app-background-color) !important;
  position: relative;
}
:host .full-screen-blog__skeleton {
  padding: 4px 0 12px;
}
:host .full-screen-blog__skeleton--overlay {
  background: var(--cms-app-background-color);
  box-sizing: border-box;
  inset: 0;
  overflow: auto;
  padding: 4px 0 12px;
  position: absolute;
  z-index: 2;
}
:host ion-list {
  background: var(--cms-app-background-color) !important;
}
:host ion-list blog-item {
  margin-bottom: 15px !important;
  border-bottom: 0px solid var(--ion-color-light);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/blog-pages/full-screen-blog/full-screen-blog.scss"],"names":[],"mappings":"AACE;EACE,wDAAA;EACA,kBAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAGI;EACE,2CAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AADN;AAKE;EACE,sDAAA;AAHJ;AAKI;EACE,8BAAA;EACA,+CAAA;EACA,0CAAA;AAHN","sourcesContent":[":host {\n  ion-content {\n    --background: var(--cms-app-background-color) !important;\n    position: relative;\n  }\n\n  .full-screen-blog__skeleton {\n    padding: 4px 0 12px;\n\n    &--overlay {\n      background: var(--cms-app-background-color);\n      box-sizing: border-box;\n      inset: 0;\n      overflow: auto;\n      padding: 4px 0 12px;\n      position: absolute;\n      z-index: 2;\n    }\n  }\n\n  ion-list {\n    background: var(--cms-app-background-color) !important;\n\n    blog-item {\n      margin-bottom: 15px !important;\n      border-bottom: 0px solid var(--ion-color-light);\n      box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
